import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { GetCommunityGroup, GetCommunityGroupResponse } from "../../api/dtos/dtos";
import useGet from "../api/useGet";

const getData = (response?: SWRResponse<GetCommunityGroupResponse, GetCommunityGroupResponse>) => response?.data?.communityGroup
const getError = (response?: SWRResponse<GetCommunityGroupResponse, GetCommunityGroupResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetCommunityGroupResponse, GetCommunityGroupResponse>) => ({});

const useGetCommunityGroup = (query?: Partial<GetCommunityGroup>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetCommunityGroup(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetCommunityGroup;